import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { FilterOutlined } from '@ant-design/icons';
import { InitiativeScopeItem } from './ScopeItem';
import { InitiativeSonarObject } from '@sonar-software/sonar-core';
import React from 'react';
import { SonarObjectType } from '@sonar-software/sonar-ts-types';

import { ColumnsType, ColumnType } from 'antd/es/table';
import {
	getSonarObjectTypeAndSourceLabel,
	isPardotType,
	isSonarObjectTypeInitiativeFilterAllowed
} from '@sonar-software/sonar-ts-lib';

type ColumnDefinition = ColumnType<InitiativeSonarObject>;

export const initiativeScopeTableNameColumn: ColumnDefinition = {
	defaultSortOrder: 'ascend',
	key: 'name',
	onCell: () => ({ colSpan: 2 }),
	render: (value, item) =>
		<InitiativeScopeItem
			initiativeId={ item.initiativeId }
			itemId={ item.id }
			sonarObjectId={ item.sonarObjectId } />,
	sortDirections: [ 'ascend', 'descend', 'ascend' ],
	sorter: true,
	title: COPY_SPECIFIC.NAME
};

const sonarObjectsFilterOptions = Object.values(SonarObjectType)
	.filter(isSonarObjectTypeInitiativeFilterAllowed)
	.filter(getSonarObjectTypeAndSourceLabel)
	.map((type) => ({
		text: getSonarObjectTypeAndSourceLabel(type),
		value: type
	}));

export const initiativeScopeTableTypeColumn: ColumnDefinition = {
	filterIcon: <FilterOutlined />,
	filters: sonarObjectsFilterOptions,
	key: 'type',
	onCell: () => ({ colSpan: 0 }),
	sortDirections: [ 'ascend', 'descend', 'ascend' ],
	sorter: true,
	title: COPY_SPECIFIC.TYPE
};

export function getInitiativeScopeTableColumns(isPardotEnabled: boolean): ColumnsType<InitiativeSonarObject> {
	if (!isPardotEnabled) {
		return [
			initiativeScopeTableNameColumn,
			{
				...initiativeScopeTableTypeColumn,
				filters: initiativeScopeTableTypeColumn.filters?.filter(
					(entry) => !isPardotType(entry.value as SonarObjectType)
				)
			}
		];
	}

	return [ initiativeScopeTableNameColumn, initiativeScopeTableTypeColumn ];
}
